/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  FeatureSectionService,
  IFeatureSectionMethods,
  IHeaderNavContentMethods,
  HeaderNavContentService,
  StaticPageContentService,
  IStaticPageContentMethods,
  TOSProductService,
  ITOSProductMethods,
  FeedbackService,
  IFeedbackMethods,
} from './components';

export type VerifyProductPageAgent = IHeaderMethods &
  IFeatureSectionMethods &
  IFooterMethods &
  IHeaderNavContentMethods &
  IStaticPageContentMethods &
  ITOSProductMethods &
  IFeedbackMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new FeatureSectionService(),
    new FooterService(),
    new HeaderNavContentService(),
    new StaticPageContentService(),
    new TOSProductService(),
    new FeedbackService(),
  ];
};

export const getAgent = () => {
  return createAgent<VerifyProductPageAgent>({
    plugins: getPlugins(),
  });
};
